import {HttpClient, HttpParams} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AssetType, AssetUploadResult} from '@gatewee/types/asset';

@Injectable({providedIn: 'root'})
export class AssetUploadService {
  constructor(
    private readonly http: HttpClient,
    @Inject('SCOPE') private readonly scope: string,
  ) {}

  upload(
    file: File,
    assetType: AssetType,
    domainId?: number,
  ): Observable<AssetUploadResult> {
    const form = new FormData();
    form.append('file', file);

    let params = new HttpParams().set('assetType', assetType);
    if (this.scope === 'admin' && domainId !== null && domainId !== undefined) {
      params = params.set('domainId', String(domainId));
    }

    return this.http.post<AssetUploadResult>(
      `/assets/${this.scope}/upload`,
      form,
      {params},
    );
  }
}
